/** 우리 회사(공급자/발주처) 고정 정보 — 거래명세표·발주서 공용 */
export const COMPANY = {
  regNo: '124-86-54198',
  name: '(주) 다모테크',
  ceo: '이계홍',
  addr: '경기도 화성시 발안로 644-72',
  tel: '031-359-9109',
  fax: '031-359-9108',
  bizType: '제조업',   // 업태 (발주서 기본값, 작성 시 수정 가능)
  bizItem: '특장차',   // 종목 (발주서 기본값, 작성 시 수정 가능)
}
